/** @format */

import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Search } from '../search';
import useQuery from 'src/hooks/useQuery';
import { useTranslation } from 'react-i18next';

export const NewsSearch = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const query = useQuery().get('query');
  const [keyword, setKeyword] = useState(query ? query : '');

  const onSubmit = () => {
    if (keyword) history.push(`/news/?query=${encodeURI(keyword)}`);
    else history.push(`/news`);
  };

  return <Search keyword={keyword} onChange={e => setKeyword(e.target.value)} onSubmit={onSubmit} />;
};
